import { z } from 'zod';
import { BaseUserDTOSchema } from "./users.dto.js";
export const FindUserByIdInputDTOSchema = z.object({
    userId: z.string().uuid(),
});
export const FindUserByIdOutputDTOSchema = BaseUserDTOSchema;
//# sourceMappingURL=find-user-by-id.dto.js.map